import React, { useState, useEffect } from 'react'
import { Button, Form, Row, Col } from "react-bootstrap"
import { withTranslation } from 'react-i18next';
import { Formik } from "formik"
import * as Yup from 'yup';

import Put from "../../api/Put";
import Get from "../../api/Get";
import {
    DISEASE_GET_ALL,
    APPOINTMENT_UPDATE,
    DISEASE_GET_ALL_NEW
} from '../../api/Routes'
import SimpleLoad from "../../loader/SimpleLoad";
import { FixedSizeList as List } from "react-window";
import Select from 'react-select';
import ComponentModalErrorSever from '../ComponentModalErrorSever';
import { toast } from 'react-toastify';


function MenuList(props) {
    const height = 35;
    const { options, children, maxHeight, getValue } = props;
    const [value] = getValue();
    const initialOffset = options.indexOf(value) * height;

    return (
        <List
            height={maxHeight}
            itemCount={children.length}
            itemSize={height}
            initialScrollOffset={initialOffset}
        >
            {({ index, style }) => <div style={style}>{children[index]}</div>}
        </List>
    );

}

function DoctorDiagnostico({ t, notify, citaID, auth, disease, idSpeciality, readOnly, fieldIndex = '' }) {
    //console.log(idSpeciality)
    const [loading, setLoading] = useState(false)
    const [loadindDataDefault, setLoadindDataDefault] = useState(false)
    const [diagnostico, setDiagnostico] = useState()
    const [options, setOptions] = useState([])
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)


    const handleClose = () => setShowModalError(false)
    const [initialValues, setInitialValues] = useState({
        diagnostico: '',
    })
    const shemaValidate = Yup.object().shape({
        diagnostico: Yup.number().required(t('Camporequerido')),
    });

    useEffect(() => {
        let mounted = true;
        Get({ url: `${DISEASE_GET_ALL}/${idSpeciality}`, access_token: auth.data.access_token })
            .then(response => {
                if (mounted) {
                    setOptions(response.data.data.response.content.map(ele => ({ value: ele.id, label: `${ele?.code4digits} - ${ele?.description}` })))
                }
            })
            .catch(error => {
                setShowModalError(true)
                if (error.response) {
                    setErrorServer(error.response)
                }
            })
        return () => mounted = false;
    }, [])

    useEffect(() => {
        if (disease && options.length > 0) {
            setLoadindDataDefault(true);
            let selectedOption;
            if (fieldIndex !== 1) {
                selectedOption = options.find(option => option.value == disease);
                console.log('ID diagnostico: ', disease);
                console.log('Opciones: ', selectedOption);
            }
            setDiagnostico(fieldIndex === 1
                ? {
                    value: disease?.id,
                    label: `${disease?.code4digits} - ${disease?.description}`,
                }
                : {
                    value: disease,
                    label: selectedOption ? selectedOption.label : 'Undefined',
                }
            );
            setInitialValues({
                ...(fieldIndex === 1 ? { diagnostico: disease?.id } : { disease: disease.id })
            });
            setLoadindDataDefault(false);
        }
    }, [disease, options]);

    return (
        <>
            <ComponentModalErrorSever
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
            {
                !readOnly ?
                    <div className="p-3 pt-4 position-relative">
                        {loading && <SimpleLoad />}
                        {
                            !loadindDataDefault &&
                            <Formik initialValues={initialValues}
                                validationSchema={shemaValidate}
                                onSubmit={(values, { setSubmitting, setFieldValue }) => {
                                    let data;
                                    if (fieldIndex === 1) {
                                        data = {
                                            id: citaID,
                                            disease: {
                                                id: values.diagnostico
                                            }
                                        }
                                    } else {
                                        data = {
                                            id: citaID,
                                            [`diagnostico${fieldIndex}`]: values.diagnostico
                                        }
                                    }
                                    /*let data = {
                                        id: citaID,
                                        [fieldIndex !== 1 ? `diagnostico${fieldIndex}` : 'disease']: {
                                            id: values.diagnostico
                                        }
                                    }*/
                                    setLoading(true)
                                    Put({ url: APPOINTMENT_UPDATE, data: data, access_token: auth.data.access_token, header: true })
                                        .then(resp => {
                                            setLoading(false)
                                            toast.success("Guadado correctamente", { autoClose: 3000 })
                                        })
                                        .catch(error => {
                                            setLoading(false)
                                            setShowModalError(true)
                                            if (error.response) {
                                                setErrorServer(error.response)
                                            }
                                        })
                                }}>{({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue
                                }) => (<Form onSubmit={handleSubmit} className='mt-3'>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label className="font-weight-bold-600 text-secondary"> {t('diagnostico')} {fieldIndex} </Form.Label>
                                                <Select
                                                    defaultValue={diagnostico}
                                                    value={diagnostico}
                                                    components={{ MenuList }}
                                                    options={options}
                                                    onChange={(item) => {
                                                        setDiagnostico(item)
                                                        setFieldValue("diagnostico", item?.value)
                                                    }}
                                                />

                                                {errors.diagnostico && <div className="invalid-feedback d-block">{errors.diagnostico}</div>}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {!readOnly && <Row className="grupoBotones">
                                        <Col className="text-right">
                                            <Button variant="outline-success" className="ok-buttom" type="submit"> {t('guardar')} </Button>{' '}
                                        </Col>
                                    </Row>}
                                </Form>)}</Formik>
                        }
                    </div> :
                    <div className="mt-5">
                        <Form.Group>
                            <Form.Label className="font-weight-bold-600 text-secondary"> {t('diagnostico')} {fieldIndex} </Form.Label>
                            <div className="form-control">
                                {`${disease?.code4digits} - ${disease?.description}`}
                            </div>
                        </Form.Group>
                    </div>
            }
        </>


    )
}

export default withTranslation()(DoctorDiagnostico)